import React from 'react';
import Input from './Input';

export default class EmailInput extends React.Component {
    getValue() {
        return this.refs.input.state.value
    }

    validate() {
        return this.refs.input.validate((val)=> {
            return /^\w+([\.-]?(\w|\!|\#|\$|\%|\&|\*|\+|\-|\/|\=|\?|\^|\_|\{|\||\}|\~|\,)+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(val);
        }, "Моля предоставете валиден е-мейл");
    }

    render() {
        return <Input ref="input" validate={this.validate.bind(this)} {...this.props} type="email" />
    }
}



// WEBPACK FOOTER //
// ./src/components/Presentation/Forms/EmailInput.js